import { createDemoPeriodComparisonMatcher } from '@web/lib/demo/utils';
import { sumBy } from '@workalizer/shared/utils';
import { calculateAverage, getInterval, getPercentageDiff, getPreviousPeriod, groupByPeriod } from '@workalizer/shared/utils';
import { endOfDay, startOfDay } from 'date-fns';
var mockCurrentPeriodData = [
    {
        docsCommentsPosted: 900,
        meetingsOrganized: 3600,
        chatMessagesSent: 1440,
        emailsSent: 360
    },
    {
        docsCommentsPosted: 0,
        meetingsOrganized: 0,
        chatMessagesSent: 600,
        emailsSent: 120
    },
    {
        docsCommentsPosted: 34343,
        meetingsOrganized: 34343,
        chatMessagesSent: 5544,
        emailsSent: 34343
    },
    {
        docsCommentsPosted: 48756,
        meetingsOrganized: 48678,
        chatMessagesSent: 1980,
        emailsSent: 0
    },
    {
        docsCommentsPosted: 35600,
        meetingsOrganized: 0,
        chatMessagesSent: 65600,
        emailsSent: 0
    },
    {
        docsCommentsPosted: 0,
        meetingsOrganized: 0,
        chatMessagesSent: 0,
        emailsSent: 0
    }
];
var mockPreviousPeriodData = [
    {
        docsCommentsPosted: 0,
        meetingsOrganized: 5400,
        chatMessagesSent: 84757,
        emailsSent: 38455
    },
    {
        docsCommentsPosted: 0,
        meetingsOrganized: 3600,
        chatMessagesSent: 600,
        emailsSent: 0
    },
    {
        docsCommentsPosted: 0,
        meetingsOrganized: 1800,
        chatMessagesSent: 1800,
        emailsSent: 120
    },
    {
        docsCommentsPosted: 0,
        meetingsOrganized: 0,
        chatMessagesSent: 3060,
        emailsSent: 34343
    },
    {
        docsCommentsPosted: 0,
        meetingsOrganized: 0,
        chatMessagesSent: 0,
        emailsSent: 0
    }
];
var mockTeamAverageData = [
    {
        docsCommentsPosted: 100,
        meetingsOrganized: 0,
        chatMessagesSent: 5220,
        emailsSent: 34343
    },
    {
        docsCommentsPosted: 34875,
        meetingsOrganized: 0,
        chatMessagesSent: 5040,
        emailsSent: 0
    },
    {
        docsCommentsPosted: 0,
        meetingsOrganized: 4747,
        chatMessagesSent: 10620,
        emailsSent: 0
    },
    {
        docsCommentsPosted: 0,
        meetingsOrganized: 48784,
        chatMessagesSent: 18180,
        emailsSent: 0
    },
    {
        docsCommentsPosted: 34584,
        meetingsOrganized: 0,
        chatMessagesSent: 4140,
        emailsSent: 0
    },
    {
        docsCommentsPosted: 34345,
        meetingsOrganized: 34343,
        chatMessagesSent: 5544,
        emailsSent: 34343
    }
];
export var timeSpentOnActivities = function (input) {
    var interval = getInterval(input.dateFrom, input.dateTo);
    var dateFrom = startOfDay(input.dateFrom);
    var dateTo = endOfDay(input.dateTo);
    var _a = getPreviousPeriod(input.dateFrom, input.dateTo), prevPeriodDateFrom = _a.prevPeriodDateFrom, prevPeriodDateTo = _a.prevPeriodDateTo;
    var periods = groupByPeriod([], dateFrom, dateTo, interval);
    var previousPeriods = groupByPeriod([], startOfDay(prevPeriodDateFrom), endOfDay(prevPeriodDateTo), interval);
    var currentPeriod = periods.map(function (period, idx) {
        var mockData = mockCurrentPeriodData[idx % mockCurrentPeriodData.length];
        if (input.userId === null) {
            return {
                period: period.date,
                docsCommentsPosted: mockData.docsCommentsPosted * 3,
                meetingsOrganized: mockData.meetingsOrganized * 2,
                chatMessagesSent: mockData.chatMessagesSent * 4,
                emailsSent: mockData.emailsSent * 2
            };
        }
        return {
            period: period.date,
            docsCommentsPosted: mockData.docsCommentsPosted,
            meetingsOrganized: mockData.meetingsOrganized,
            chatMessagesSent: mockData.chatMessagesSent,
            emailsSent: mockData.emailsSent
        };
    });
    var periodMatcher = createDemoPeriodComparisonMatcher(input, interval, periods, previousPeriods);
    var previousPeriod = periods.map(function (_, idx) {
        var _a;
        var prevPeriod = periodMatcher.getItem(idx, previousPeriods);
        var previousIndex = prevPeriod
            ? previousPeriods.indexOf(prevPeriod)
            : null;
        var mockData = mockPreviousPeriodData[(previousIndex !== null && previousIndex !== void 0 ? previousIndex : idx) % mockPreviousPeriodData.length];
        var periodLabel = (_a = prevPeriod === null || prevPeriod === void 0 ? void 0 : prevPeriod.date) !== null && _a !== void 0 ? _a : '';
        if (input.userId === null) {
            return {
                period: periodLabel,
                docsCommentsPosted: mockData.docsCommentsPosted * 3,
                meetingsOrganized: mockData.meetingsOrganized * 2,
                chatMessagesSent: mockData.chatMessagesSent * 4,
                emailsSent: mockData.emailsSent * 2
            };
        }
        return {
            period: periodLabel,
            docsCommentsPosted: mockData.docsCommentsPosted,
            meetingsOrganized: mockData.meetingsOrganized,
            chatMessagesSent: mockData.chatMessagesSent,
            emailsSent: mockData.emailsSent
        };
    });
    var teamAverage = periods.map(function (period, idx) {
        var mockData = mockTeamAverageData[idx % mockTeamAverageData.length];
        return {
            period: period.date,
            docsCommentsPosted: mockData.docsCommentsPosted,
            meetingsOrganized: mockData.meetingsOrganized,
            chatMessagesSent: mockData.chatMessagesSent,
            emailsSent: mockData.emailsSent
        };
    });
    var totalDocsComments = sumBy(currentPeriod, 'docsCommentsPosted');
    var totalMeetings = sumBy(currentPeriod, 'meetingsOrganized');
    var totalChatMessages = sumBy(currentPeriod, 'chatMessagesSent');
    var totalEmails = sumBy(currentPeriod, 'emailsSent');
    var prevTotalDocsComments = sumBy(previousPeriod, 'docsCommentsPosted');
    var prevTotalMeetings = sumBy(previousPeriod, 'meetingsOrganized');
    var prevTotalChatMessages = sumBy(previousPeriod, 'chatMessagesSent');
    var prevTotalEmails = sumBy(previousPeriod, 'emailsSent');
    var docsCommentsDiff = getPercentageDiff(prevTotalDocsComments, totalDocsComments);
    var meetingsDiff = getPercentageDiff(prevTotalMeetings, totalMeetings);
    var chatMessagesDiff = getPercentageDiff(prevTotalChatMessages, totalChatMessages);
    var emailsDiff = getPercentageDiff(prevTotalEmails, totalEmails);
    var teamTotalDocsComments = sumBy(teamAverage, 'docsCommentsPosted');
    var teamTotalMeetings = sumBy(teamAverage, 'meetingsOrganized');
    var teamTotalChatMessages = sumBy(teamAverage, 'chatMessagesSent');
    var teamTotalEmails = sumBy(teamAverage, 'emailsSent');
    var teamAvgDocsComments = calculateAverage(teamTotalDocsComments, 4);
    var teamAvgMeetings = calculateAverage(teamTotalMeetings, 4);
    var teamAvgChatMessages = calculateAverage(teamTotalChatMessages, 4);
    var teamAvgEmails = calculateAverage(teamTotalEmails, 4);
    var teamDocsCommentsDiff = getPercentageDiff(teamAvgDocsComments, totalDocsComments);
    var teamMeetingsDiff = getPercentageDiff(teamAvgMeetings, totalMeetings);
    var teamChatMessagesDiff = getPercentageDiff(teamAvgChatMessages, totalChatMessages);
    var teamEmailsDiff = getPercentageDiff(teamAvgEmails, totalEmails);
    var result = {
        totals: {
            docsCommentsPosted: totalDocsComments,
            meetingsOrganized: totalMeetings,
            chatMessagesSent: totalChatMessages,
            emailsSent: totalEmails,
            prevPeriodDiffs: {
                docsCommentsPosted: docsCommentsDiff,
                meetingsOrganized: meetingsDiff,
                chatMessagesSent: chatMessagesDiff,
                emailsSent: emailsDiff
            }
        },
        currentPeriod: currentPeriod,
        previousPeriod: previousPeriod
    };
    if (input.userId !== null) {
        result.totals.teamAverageDiffs = {
            docsCommentsPosted: teamDocsCommentsDiff,
            meetingsOrganized: teamMeetingsDiff,
            chatMessagesSent: teamChatMessagesDiff,
            emailsSent: teamEmailsDiff
        };
        result.teamAverage = teamAverage;
    }
    return result;
};
